export default __webpack_public_path__ + "static/media/RvWhite.18047b48.svg";